// extracted by mini-css-extract-plugin
export default {"background":"Signup_background__X2het","signup-form":"Signup_signup-form__I2SH4","photo":"Signup_photo__8BsID","login":"Signup_login__+qFFc","thumbnail":"Signup_thumbnail__GMYqv"};